import "./config";
import "./styles.css";
import "./styles.global.css";

(async () => {
  await import("@redotech/redo-shopify-extension/index");
  console.log("Redo Bigcommerce bootstrap initialized v2.");
})();
